class ucbVideoSection extends HTMLElement {
    constructor() {
        super();

        this.muteBtn = this.querySelector('[data-ucb-mute-btn]');
        this.videos = this.querySelectorAll('[data-ucb-video]');
        this.desktopWrapper = this.querySelector('.ucb-video__desktop');
        this.mobileWrapper = this.querySelector('.ucb-video__mobile');

        if (!this.muteBtn || !this.videos.length) return;

        this.wasUnmuted = false;

        this.initMuteToggle();
        this.initAutoplayObserver();
        this.initResponsiveSwitch();
        this.syncActiveVideo();
    }

    /* ---------- Determine which wrapper is currently visible ---------- */
    getActiveWrapper() {
        if (this.desktopWrapper && getComputedStyle(this.desktopWrapper).display !== 'none') {
            return this.desktopWrapper;
        }
        return this.mobileWrapper;
    }

    /* ---------- Pause hidden videos, play the visible one ---------- */
    syncActiveVideo() {
        var activeWrapper = this.getActiveWrapper();

        this.videos.forEach(function (v) {
            var parent = v.closest('.ucb-video__desktop') || v.closest('.ucb-video__mobile');

            if (parent === activeWrapper) {
                v.play().catch(function () { });
            } else {
                v.pause();
                v.currentTime = 0;
            }
        });
    }

    /* ---------- Listen for viewport changes to swap videos ---------- */
    initResponsiveSwitch() {
        var self = this;
        var mql = window.matchMedia('(max-width: 749px)');

        function handleChange() {
            self.syncActiveVideo();
        }

        if (mql.addEventListener) {
            mql.addEventListener('change', handleChange);
        } else {
            mql.addListener(handleChange);
        }
    }

    /* ---------- Mute / Unmute toggle ---------- */
    initMuteToggle() {
        this.muteBtn.addEventListener('click', this.handleMuteToggle.bind(this));
    }

    handleMuteToggle() {
        var isMuted = this.videos[0].muted;

        this.videos.forEach(function (v) {
            v.muted = !isMuted;
        });

        this.wasUnmuted = isMuted;

        if (isMuted) {
            this.muteBtn.classList.add('is-unmuted');
            this.muteBtn.setAttribute('aria-label', 'Mute video');
        } else {
            this.muteBtn.classList.remove('is-unmuted');
            this.muteBtn.setAttribute('aria-label', 'Unmute video');
        }
    }

    /* ---------- Play / Pause on scroll visibility ---------- */
    initAutoplayObserver() {
        var self = this;
        var observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    self.handleVisibilityChange(entry);
                });
            },
            { threshold: 0.3 }
        );
        observer.observe(this);
    }

    handleVisibilityChange(entry) {
        var self = this;
        var activeWrapper = self.getActiveWrapper();

        if (entry.isIntersecting) {
            /* scrolled back into view — resume and restore audio state */
            self.videos.forEach(function (v) {
                var parent = v.closest('.ucb-video__desktop') || v.closest('.ucb-video__mobile');
                if (parent === activeWrapper) {
                    v.muted = !self.wasUnmuted;
                    v.play().catch(function () { });
                }
            });

            if (self.wasUnmuted) {
                self.muteBtn.classList.add('is-unmuted');
                self.muteBtn.setAttribute('aria-label', 'Mute video');
            } else {
                self.muteBtn.classList.remove('is-unmuted');
                self.muteBtn.setAttribute('aria-label', 'Unmute video');
            }
        } else {
            /* scrolled out of view — pause and mute */
            self.videos.forEach(function (v) {
                v.pause();
                v.muted = true;
            });

            self.muteBtn.classList.remove('is-unmuted');
            self.muteBtn.setAttribute('aria-label', 'Unmute video');
        }
    }
}

customElements.define('ucb-video-section', ucbVideoSection);
